import { Backdrop, Box, Button, Checkbox, CircularProgress, FormControlLabel, Stack, TextField, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../App";


export default function SendBillets({billets, close, setSnack}) {
    const { setIsConnected } = useContext(Context)
    const [toOwner, setToOwner] = useState(true)
    const [mails, setmails]=useState('')
    const [name, setName] = useState('')
    const [load, setLoad] = useState(false)

    function handleSubmit(event) {
        event.preventDefault();
        setLoad(true)
        
        const emails = mails.replace(/\s/g, '').split(';').filter(mail=> mail!=='')
        const regex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
        //alerte si aucune adresse mail ou bad format
        if (!toOwner&&emails.length<=0) {
            setLoad(false)
            return alert('Aucun destinataire spécifié!')
        }

        for(let i = 0; i < emails.length; i++) {
            if (!regex.test(emails[i])) {
                setLoad(false)
                return alert("Le format d'une ou plusieurs des adresses mail que vous avez spécifiées est incorrecte.")
            }
        }

        fetch(process.env.REACT_APP_API_URL.concat(`/billets/send`), {method:'POST', headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify({emails, toOwner, billets, name})
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                setIsConnected(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                setSnack(response.ok ? "Billet(s) envoyé(s) avec succès" : "Échec de l'envoie")
                close()
                setLoad(false)
            }
        })
    }

    return(
        <Box component={'form'} onSubmit={handleSubmit} display='flex' flexDirection='column' sx={{padding:'20px'}}>
            <Typography variant="h4" color="focus" align="center">Envoie {billets.length >1 ? `de ${billets.length} billets` : "d'un billet"} </Typography>

            <Typography variant="body1" sx={{mt:2, mb:1}}>Envoyer par e-mail à </Typography>
            <TextField sx={{ml:5}} color="focus" type="email" multiline rows={3} value={mails} 
            placeholder="Entrez les adresses e-mail séparées par des ;(point-virgule)"  onChange={(e)=>setmails(e.target.value)}/>

            <FormControlLabel sx={{mt:2}} label={`Envoyer individuellement à chaque utilisateur`} control={<Checkbox color="focus" checked={toOwner} onClick={()=>setToOwner(old=> !old)}/>}/>

            <Typography variant="body1" sx={{mt:2, mb:1}}>Nom du destinataire</Typography>
            <TextField sx={{ml:5}} color="focus" type="text" value={name} onChange={(e)=>setName(e.target.value)}/>

            <Stack direction="row" spacing={2} marginTop={2} alignSelf='center'>
                <Button variant="outlined" color="focus" onClick={close}>Annuler</Button>
                <Button type="submit" variant="contained" color="focus" sx={{color: 'white'}}>Envoyer</Button>
            </Stack>

            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
    
}